import { store } from '@atredux/store'
import { setNotificationCount } from '@atredux/slices/notificationSlice'

export async function syncNotificationCountListener (message) {
    const count = message?.data?.notificationCount
    if (typeof count !== 'number') {
        console.warn(`ATBase: syncNotificationCount received invalid count: ${JSON.stringify(message?.data)}`)
        return true
    }
    console.log(`Syncing notification count with new count: ${count}`)
    store.dispatch(setNotificationCount(count))
    return true
}
